<template>
  <div class="legal-cfg">
    <p class="legal-cfg__description">
      Configura los textos legales que se incluyen en los documentos enviados a
      tus clientes.
    </p>

    <div class="legal-cfg__section">
      <label class="font-semi-bold legal-cfg__label">
        Términos y Condiciones
      </label>
      <p class="legal-cfg__hint">
        Este texto se mostrará en tus documentos (facturas, cotizaciones, etc.).
      </p>
      <EditorWysiwygComponent
        @onEditorChange="({ text }) => (userConfigText.legal = text)"
        :setText.sync="userConfigText.legal"
      />
    </div>

    <div class="legal-cfg__section">
      <label class="font-semi-bold legal-cfg__label">
        Política de Privacidad
      </label>
      <p class="legal-cfg__hint">
        Texto de política de privacidad para tus clientes.
      </p>
      <EditorWysiwygComponent
        @onEditorChange="({ text }) => (userConfigText.privacy_policy = text)"
        :setText.sync="userConfigText.privacy_policy"
      />
    </div>

    <div class="legal-cfg__section">
      <label class="font-semi-bold legal-cfg__label">
        Aviso Legal
      </label>
      <p class="legal-cfg__hint">
        Aviso o nota legal adicional para incluir en tus documentos.
      </p>
      <EditorWysiwygComponent
        @onEditorChange="({ text }) => (userConfigText.legal_notice = text)"
        :setText.sync="userConfigText.legal_notice"
      />
    </div>

    <div class="legal-cfg__actions">
      <button
        type="button"
        class="btn md__btn-primary"
        @click="handleSaveClick"
      >
        Guardar cambios
      </button>
    </div>
  </div>
</template>

<script>
import configService from "../../services/configService";
import EditorWysiwygComponent from "../../../components/EditorWysiwyg";

export default {
  name: "PreferencesLegalComponent",
  components: {
    EditorWysiwygComponent
  },
  data: () => ({
    userConfigText: {
      legal: "",
      privacy_policy: "",
      legal_notice: ""
    }
  }),
  methods: {
    async handleGetUserConfigTexts() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const businessId = this.$store.getters.getUser?.user_business?.id;
        const response = await configService
          .getUserConfigTexts(businessId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        if (response.data && response.data.data) {
          const data = response.data.data;
          this.userConfigText = {
            ...this.userConfigText,
            ...data
          };
        }
      } catch (error) {
        return false;
      }
    },
    async handleSaveClick() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const businessId = this.$store.getters.getUser?.user_business?.id;
        const response = await configService
          .updateUserConfigTexts(this.userConfigText, businessId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        if (response && response.data) {
          const { success, message, data } = response.data;
          if (success) {
            if (data) {
              this.userConfigText = {
                ...this.userConfigText,
                ...data
              };
            }
            this.$notifications.success({ message });
          }
        }
      } catch (error) {
        return false;
      }
    }
  },
  mounted() {
    this.handleGetUserConfigTexts();
  }
};
</script>

<style scoped>
.legal-cfg__description {
  color: #6b7280;
  margin-bottom: 24px;
  font-size: 14px;
}

.legal-cfg__section {
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid #f0f0f0;
}

.legal-cfg__section:last-of-type {
  border-bottom: none;
}

.legal-cfg__label {
  display: block;
  color: #31355c;
  font-size: 14px;
  margin-bottom: 6px;
}

.legal-cfg__hint {
  color: #9ca3af;
  font-size: 12px;
  margin-bottom: 12px;
}

.legal-cfg__actions {
  margin-top: 8px;
  padding-top: 16px;
}
</style>
